import { Reducer } from 'redux';
import { DriverTypes, InitialDriver } from './types';

const INITIAL_STATE: InitialDriver = {
  driverId: '',
  username: '',
  email: '',
  cpf: '',
  rg: '',
  phoneNumber: '',
  birthDate: '',
  resetPasswordToken: '',
  resetPasswordSentAt: '',
  status: '',
  createdAt: '',
  updatedAt: '',
  imageUrl: '',
  selfie: '',
  driverLicense: {
    driverLicenseId: '',
    front: '',
    back: '',
    selfie: '',
    length: '',
    categories: null,
    createdAt: '',
    updatedAt: '',
  },
  vehicle: {
    vehicleId: '',
    model: '',
    year: '',
    plate: '',
    weight: '',
    payloadCapacity: '',
    length: '',
    width: '',
    frontVehicle: '',
    backVehicle: '',
    leftVehicle: '',
    rightVehicle: '',
    createdAt: '',
    updatedAt: '',
    crlv: {
      imageUrl: '',
    },
    vehicleType: {
      vehicleType: '',
    },
  },
  freight: [
    {
      freightId: '',
      freightCost: 0,
      totalKilometers: 0,
      numberOfHelpers: 0,
      deliveryLimitDate: '',
      freightStatus: '',
      vehicleTypePrice: 0,
      totalWeight: 0,
      pickUpDate: '',
      acceptDate: '',
      createdAt: '',
      updatedAt: '',
      deliveries: [
        {
          loadNumbers: '',
          orders: [
            {
              numberOfOrders: 0,
            },
          ],
        },
      ],
    },
  ],
  refusedData: [],
  reasonsRefusalDraft: [],
};
const reduceDriver: Reducer<InitialDriver> = (
  state = INITIAL_STATE,
  action,
) => {
  switch (action.type) {
    case DriverTypes.GET_DRIVER: {
      return { ...state, ...action.payload };
    }
    case DriverTypes.SET_REFUSED_DATAS: {
      const newState = { ...state };

      newState.refusedData = action.payload.refusedData;
      newState.driverId = action.payload.driverId;
      return newState;
    }

    case DriverTypes.SET_REFUSED_DATAS_DRAFT: {
      const newState = { ...state };

      const reasonRefusalIndex = newState.reasonsRefusalDraft.findIndex(
        reason => reason.step === action.payload.reasonsRefusalDraft.step,
      );

      if (reasonRefusalIndex !== -1) {
        newState.reasonsRefusalDraft[reasonRefusalIndex].reasonRefusalId =
          action.payload.reasonsRefusalDraft.reasonRefusalId;
      } else {
        newState.reasonsRefusalDraft.push(action.payload.reasonsRefusalDraft);
      }

      return newState;
    }

    case DriverTypes.SET_CLEAR_ALL_REFUSED_DATAS: {
      const newState = { ...INITIAL_STATE };
      newState.reasonsRefusalDraft = [];

      return newState;
    }

    default:
      return state;
  }
};
export default reduceDriver;
